module.exports = __webpack_public_path__ + "img/MinisteriumWirtschaft.480ee7f0.png";